import {Route, Routes} from "react-router-dom";
import {useEffect} from "react";
import InDevelopment from "./pages/General/InDeveloppement";
import NotFound from "./pages/General/NotFound";
import Login from "./pages/Auth/Login";
import 'react-toastify/dist/ReactToastify.css';
import Main from "./pages/General/Main";
import Manage from "./pages/Manage/Manage";
import Profile from "./pages/Auth/Profile";
import ContactForm from "./pages/Auth/ContactForm";
import Register from "./pages/Auth/Register";
import ResetPassword from "./pages/Auth/ResetPassword";
import VerifyEmail from "./pages/Auth/VerifyEmail";
import axios from "axios";
import Truck from "./pages/Truck/Truck";
import {message} from "antd";
import TruckDetails from "./pages/Truck/truckDetails";
import Statistics from "./pages/Statistics/Statistics";
import Trailer from "./pages/Trailer/Trailer";
import TrailerDetails from "./pages/Trailer/trailerDetails";
import CarDetails from "./pages/Car/carDetails";
import Car from "./pages/Car/Car";
import Van from "./pages/Van/Van";
import VanDetails from "./pages/Van/vanDetails";
import {useAuth} from "./contexts/AuthContext";

export function MyRoutes() {
    const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL || "https://kimmel-parc.fr/api";
    const authContext = useAuth()

    useEffect(() => {
        checkAdminUsersExists()
    }, [])

    const checkAdminUsersExists = () => {
        axios.get(`${BACKEND_API_URL}/user/email/forster.frederic@gmail.com`, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.status === 200 && res.data.success === false)
                axios.post(`${BACKEND_API_URL}/user/`, {firstName: "Frédéric", lastName: "Forster", email: "forster.frederic@gmail.com", password: "Frederic137*", userValidated: true, isAdmin: true, isSuperAdmin: true, isEmailValid: true},{
                    headers: { "Content-Type": "application/json" },
                }).then(() => {
                    console.log("Mandatory admin user \"forster.frederic@gmail.com\" created")
                })
        }).catch((err) => {console.error(err)})
    }

    message.config({
        top: 100,
        duration: 2,
        maxCount: 3,
    });

    return (
        <Routes>
            <Route path="/login" element={<Login backendApiUrl={BACKEND_API_URL}/>}/>
            <Route path="/register" element={<Register backendApiUrl={BACKEND_API_URL}/>}/>
            <Route path="/reset-password" element={<ResetPassword backendApiUrl={BACKEND_API_URL}/>}/>
            <Route path="/verify-email" element={<VerifyEmail backendApiUrl={BACKEND_API_URL}/>}/>
            <Route path="/" element={<Main/>}>
                <Route path="/" element={<Statistics backendApiUrl={BACKEND_API_URL}/>}/>
                <Route path="/trailers" element={<Trailer backendApiUrl={BACKEND_API_URL}/>}/>
                <Route path="/trailer-details" element={<TrailerDetails backendApiUrl={BACKEND_API_URL}/>}/>
                <Route path="/trucks" element={<Truck backendApiUrl={BACKEND_API_URL}/>}/>
                <Route path="/truck-details" element={<TruckDetails backendApiUrl={BACKEND_API_URL}/>}/>`
                <Route path="/vans" element={<Van backendApiUrl={BACKEND_API_URL}/>}/>
                <Route path="/van-details" element={<VanDetails backendApiUrl={BACKEND_API_URL}/>}/>
                <Route path="/cars" element={<Car backendApiUrl={BACKEND_API_URL}/>}/>
                <Route path="/car-details" element={<CarDetails backendApiUrl={BACKEND_API_URL}/>}/>
                {authContext.currentUser?.isSuperAdmin && (
                    <Route path="/manage" element={<Manage backendApiUrl={BACKEND_API_URL}/>}/>
                )}
                <Route path="/profile" element={<Profile backendApiUrl={BACKEND_API_URL}/>}/>
                <Route path="/contact-us" element={<ContactForm backendApiUrl={BACKEND_API_URL}/>}/>
                <Route path="*" element={<NotFound/>}/>
            </Route>
            <Route path="/in-development" element={<InDevelopment/>}/>
        </Routes>
    );
}

export default MyRoutes;
